// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card-module [data-toggle=collapse]:before{top:26% !important;font-size:1.6rem !important;font-family:\"boxicons\";content:\"\" !important}.card-module [contenteditable]{display:inline-block;outline:none;padding:5px 10px;margin-top:5px;content:attr(placeholder)}.card-module .card-module{margin:0 -1px !important}", ""]);
// Exports
module.exports = exports;
